import { api } from 'api';

import { AppThunk } from 'store';
import {
  setError,
  setIsLoadingPromo,
  setPackagesPromo
} from 'store/reducers/packagesSlice';

export const getPackagesPromo = (): AppThunk => async (dispatch) => {
  try {
    dispatch(setIsLoadingPromo(true));
    const { data } = await api.packages.getPackagesPromo();
    dispatch(setPackagesPromo(data));
  } catch (error) {
    console.error(`Error while get packages promo: ${error.message}`);
    dispatch(setError(error.response?.data?.error || error.message));
  } finally {
    dispatch(setIsLoadingPromo(false));
  }
};
